import { useEffect } from 'react';
import { motion } from 'framer-motion';
import SectionHeader from '../components/SectionHeader';
import Button from '../components/Button';
import { FadeIn, StaggerContainer, StaggerItem } from '../components/FadeIn';

export const Planos = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const products = [
    {
      to: '/planos/fazenda-leiteira',
      icon: 'fas fa-cow',
      emoji: '🐄',
      title: 'Fazenda Leiteira',
      desc: 'Controle produção, rebanho, custos, estoque e lucratividade da propriedade.',
      color: '#22c55e',
      gradient: 'linear-gradient(135deg, #16a34a, #14b8a6)',
    },
    {
      to: '/planos/controle-de-obras',
      icon: 'fas fa-helmet-safety',
      emoji: '🏗️',
      title: 'Controle de Obras',
      desc: 'Cronograma, etapas, custos, materiais, equipes e evolução das obras.',
      color: '#f59e0b',
      gradient: 'linear-gradient(135deg, #d97706, #0284c7)',
    },
    {
      to: '/planos/locafacil-obras',
      icon: 'fas fa-truck-ramp-box',
      emoji: '🚜',
      title: 'LocaFácil Obras',
      desc: 'Equipamentos, contratos, reservas, manutenção, devoluções e faturamento.',
      color: '#06b6d4',
      gradient: 'linear-gradient(135deg, #0891b2, #4338ca)',
    },
    {
      to: '/planos/atende24h',
      icon: 'fas fa-robot',
      emoji: '🤖',
      title: 'Atende24h IA',
      desc: 'WhatsApp, IA, automações, multiatendimento, histórico e relatórios.',
      color: '#6366f1',
      gradient: 'linear-gradient(135deg, #2563eb, #06b6d4, #6366f1)',
    },
  ];

  return (
    <div style={{ marginTop: '80px' }}>
      <section
        style={{
          padding: '6rem 0',
          background:
            'radial-gradient(circle at top left, rgba(56,189,248,.20), transparent 32%), radial-gradient(circle at bottom right, rgba(99,102,241,.18), transparent 34%), linear-gradient(135deg, #020617 0%, #0f172a 50%, #111827 100%)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <motion.div
          animate={{ scale: [1, 1.15, 1], rotate: [0, 180, 360] }}
          transition={{ duration: 26, repeat: Infinity, ease: 'linear' }}
          style={{
            position: 'absolute',
            top: '-22%',
            right: '-12%',
            width: '620px',
            height: '620px',
            background:
              'radial-gradient(circle, rgba(56,189,248,.14) 0%, transparent 70%)',
            borderRadius: '50%',
          }}
        />

        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <FadeIn>
            <div style={{ maxWidth: '850px', margin: '0 auto', textAlign: 'center' }}>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '.5rem',
                  padding: '.5rem 1rem',
                  background: 'rgba(56,189,248,.12)',
                  border: '1px solid rgba(56,189,248,.32)',
                  borderRadius: '999px',
                  color: '#7dd3fc',
                  fontSize: '.9rem',
                  fontWeight: 700,
                  marginBottom: '1.5rem',
                }}
              >
                <i className="fas fa-layer-group" />
                Planos por solução
              </div>

              <h1
                style={{
                  fontSize: 'clamp(2.4rem, 5vw, 4.2rem)',
                  fontWeight: 900,
                  color: '#fff',
                  lineHeight: 1.05,
                  marginBottom: '1.5rem',
                  letterSpacing: '-1.5px',
                }}
              >
                Escolha a solução ideal para o{' '}
                <span
                  style={{
                    background:
                      'linear-gradient(135deg, #38bdf8, #22d3ee, #6366f1)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  seu negócio
                </span>
              </h1>

              <p
                style={{
                  fontSize: '1.18rem',
                  color: '#cbd5e1',
                  lineHeight: 1.7,
                  maxWidth: '720px',
                  margin: '0 auto',
                }}
              >
                Cada produto possui planos específicos para sua realidade.
                Selecione a plataforma que deseja conhecer.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      <section style={{ padding: '5.5rem 0', background: 'var(--bg-primary)' }}>
        <div className="container">
          <FadeIn>
            <SectionHeader
              title="Planos organizados por produto"
              subtitle="Assim você vê apenas os preços e recursos da solução que realmente faz sentido para sua operação."
            />
          </FadeIn>

          <StaggerContainer
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
              gap: '1.5rem',
              marginTop: '3rem',
            }}
          >
            {products.map((product) => (
              <StaggerItem key={product.title}>
                <motion.div
                  whileHover={{ y: -8 }}
                  style={{
                    height: '100%',
                    padding: '1rem',
                    borderRadius: '30px',
                    background: 'var(--bg-tertiary)',
                    border: '1px solid rgba(148,163,184,.18)',
                    boxShadow: '0 20px 55px rgba(15,23,42,.08)',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      minHeight: '150px',
                      borderRadius: '24px',
                      background: product.gradient,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '1.5rem',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        inset: 0,
                        background:
                          'radial-gradient(circle at top right, rgba(255,255,255,.28), transparent 36%)',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '4rem',
                        position: 'relative',
                        zIndex: 1,
                        filter: 'drop-shadow(0 12px 24px rgba(0,0,0,.22))',
                      }}
                    >
                      {product.emoji}
                    </span>
                  </div>

                  <div style={{ padding: '0 .75rem 1rem' }}>
                    <div
                      style={{
                        width: '52px',
                        height: '52px',
                        borderRadius: '17px',
                        background: `${product.color}22`,
                        color: product.color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.35rem',
                        marginBottom: '1rem',
                      }}
                    >
                      <i className={product.icon} />
                    </div>

                    <h3
                      style={{
                        color: 'var(--dark)',
                        marginBottom: '.75rem',
                        fontSize: '1.35rem',
                      }}
                    >
                      {product.title}
                    </h3>

                    <p
                      style={{
                        color: 'var(--gray)',
                        lineHeight: 1.7,
                        marginBottom: '1.5rem',
                      }}
                    >
                      {product.desc}
                    </p>

                    <Button to={product.to} style={{ width: '100%', justifyContent: 'center' }}>
                      Ver Planos
                    </Button>
                  </div>
                </motion.div>
              </StaggerItem>
            ))}
          </StaggerContainer>
        </div>
      </section>

      <section style={{ padding: '5rem 0', background: 'var(--bg-tertiary)' }}>
        <div className="container">
          <FadeIn>
            <div
              style={{
                borderRadius: '30px',
                padding: '3rem',
                background:
                  'linear-gradient(135deg, rgba(56,189,248,.14), rgba(99,102,241,.10))',
                border: '1px solid rgba(56,189,248,.24)',
                textAlign: 'center',
              }}
            >
              <h2
                style={{
                  fontSize: 'clamp(2rem, 4vw, 3rem)',
                  marginBottom: '1rem',
                  color: 'var(--dark)',
                }}
              >
                Ainda não sabe qual solução escolher?
              </h2>

              <p
                style={{
                  color: 'var(--gray)',
                  fontSize: '1.1rem',
                  lineHeight: 1.7,
                  maxWidth: '760px',
                  margin: '0 auto 2rem',
                }}
              >
                Fale com a gente e vamos te ajudar a identificar o melhor
                sistema para o seu momento.
              </p>

              <motion.div
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.96 }}
                style={{ display: 'inline-block' }}
              >
                <Button to="/contato">
                  <i className="fab fa-whatsapp" /> Falar com Especialista
                </Button>
              </motion.div>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>
  );
};

export default Planos;